/**
 * AI CONTEXT
 * Purpose: manager-only chat-stream notes about a staff member (popover
 *   trigger + thread + input). Renders nothing for roles without the
 *   STAFF_NOTE permission.
 * Used by: StandoutTeacherStats (Standout Review dashboard) and UserProfile.
 */
import { FileTextOutlined } from "@ant-design/icons"
import { Button, Popover, Typography } from "antd"

import { ProtectedComponent } from "#components/ProtectedComponent"
import { RESOURCES, USER_ACTIONS } from "#customTypes/composedTypes/authTypes"
import { Uuid } from "#customTypes/globalTypes"

import StaffNotesThread from "./StaffNotesThread"

const { Text } = Typography

export interface StaffNotesPopoverProps {
  subjectUserId: Uuid
  subjectName: string
  buttonSize?: "small" | "middle"
}

const StaffNotesPopover = ({
  subjectUserId,
  subjectName,
  buttonSize = "small",
}: StaffNotesPopoverProps) => {
  return (
    <ProtectedComponent
      resource={RESOURCES.STAFF_NOTE}
      action={USER_ACTIONS.READ}
    >
      <Popover
        trigger="click"
        destroyTooltipOnHide
        title={<Text strong>Notes on {subjectName}</Text>}
        content={
          <div style={{ width: 400 }}>
            <StaffNotesThread subjectUserId={subjectUserId} maxHeight={300} />
          </div>
        }
      >
        <Button
          data-testid="staff-notes-button"
          size={buttonSize}
          icon={<FileTextOutlined />}
        >
          Notes
        </Button>
      </Popover>
    </ProtectedComponent>
  )
}

export default StaffNotesPopover
